export default __webpack_public_path__ + "af035d6bbf67dd7eadb478401f62e8ec.svg";